import { render } from "./ThePagination.vue?vue&type=template&id=2bb2ec94&scoped=true"
import script from "./ThePagination.vue?vue&type=script&lang=js"
export * from "./ThePagination.vue?vue&type=script&lang=js"

import "./ThePagination.vue?vue&type=style&index=0&id=2bb2ec94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb2ec94"]])

export default __exports__